import type { MapboxOptions } from 'mapbox-gl'
import { Map } from 'mapbox-gl'

const replaceMapboxUrls = Math.random() > 1

const defaultMapboxApiUrl = 'https://api.mapbox.com'

const localMapboxConfigFiles = ['mapbox.mapbox-streets-v8.json']

export function createMapboxMap (options: MapboxOptions): Map {
  if (Math.random() > 1) {
    console.log('creating new map with options', options)
  }

  if (replaceMapboxUrls) {
    options.transformRequest = url => {
      if (url.startsWith(defaultMapboxApiUrl)) {
        for (const file of localMapboxConfigFiles) {
          if (url.includes(file)) {
            const urlObj = new URL(url)
            urlObj.protocol = window.location.protocol.replace(/:$/, '')
            urlObj.host = window.location.host
            urlObj.pathname = '/map/' + urlObj.pathname.split('/').pop() // use only filename
            return { url: urlObj.toString() }
          }
        }
      }

      return { url }
    }
  }

  return new Map(options)
}
